import React, { PureComponent } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ModalComponent from '../../../ui/Modal';
import FormikRadioButtonAlternate from '../../../ui/FormikRadioButtonAlternate';
import { DiscountSchema } from '../validation';

import { addValidDates, removeValidDate, renderDates } from './AddOnModal';

const blankDiscount = {
  name: '',
  code: '',
  discountPercentage: '',
  discountDollarAmount: '',
  validDates: [],
  new: true,
  discountType: 'Percentage',
  hasDateRange: false,
};

class DiscountModalComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      validDatesStatusYes: true,
      validDatesStatusNo: false
    }

    this.onSubmit = this.onSubmit.bind(this);
  }
  bindSubmitForm = (submitForm) => { this.submitForm = submitForm; }
  handleFormSubmit = (e) => { if (this.submitForm) { this.submitForm(e); } }
  onSubmit = (values) => {
    this.props.onSubmit(values);
    this.toRef = null;
  }

  renderBody = (bindSubmitForm, onSubmit) => {
    let initialValues = this.props.discount ? this.props.discount : blankDiscount;
    if (!this.props.discount) { initialValues.validDates = []; }
    if (initialValues.validDates.length > 0) { initialValues.hasDateRange = true; }
    initialValues.dateRangeType = 'single';

    return (<div>
      <div className="col-12" className="discounts">
        <Formik
          initialValues={initialValues}
          validationSchema={DiscountSchema}
          onSubmit={onSubmit}>
          {({ values, errors, setFieldValue, submitForm }) => {
            bindSubmitForm(submitForm);
            return (<Form>
              <div className="fieldgroup row">
                <div className="col-6 col-md-5 edit-field-parent reset-padding">
                  <div className="field-title">Name</div>
                </div>
                <div className="col-6 col-md-7">
                  <div className="edit-radio-button-container">
                    <div className="row">
                      <Field
                        name="name"
                        type="text"
                        placeholder="ex. Military or Family & Friends"
                        className="form-control form-field"
                      />
                      <ErrorMessage name="name" component="div" className="error-message" />
                    </div>
                    <div className="row">
                      <div className="disclaimer">Renters will not see this name.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fieldgroup row">
                <div className="col-6 col-md-5 edit-field-parent reset-padding">
                  <div className="field-title">Code</div>
                </div>
                <div className="col-6 col-md-7">
                  <div className="edit-radio-button-container">
                    <div className="row">
                      <Field
                        name="code"
                        type="text"
                        placeholder="ex. 15OFF or NYES"
                        className="form-control form-field"
                      />
                      <ErrorMessage name="code" component="div" className="error-message" />
                    </div>
                    <div className="row">
                      <div className="disclaimer">Code cannot be more than 8 characters and can only contain letters and numbers. You cannot reuse codes.</div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="fieldgroup row">
                <div className="col-6 col-md-5 edit-field-parent reset-padding">
                  <div className="field-title">Discount (per night)</div>
                </div>
                <div className="col-6 col-md-7">
                  <div className="edit-radio-button-container">
                    <div className="row">
                      <div className="col-12 col-md-6 reset-padding">
                        <FormikRadioButtonAlternate
                          name="discountType"
                          value="Percentage"
                          label="Percentage (%)"
                          labelClassName="d-flex"
                          //onClick={() => this.setDiscountPercentage(values)}
                          checked={values.discountType === "Percentage"}
                        />
                      </div>
                      <div className="col-12 col-md-6 reset-padding">
                        <FormikRadioButtonAlternate
                          name="discountType"
                          value="DollarAmount"
                          label="Dollar Amount ($)"
                          labelClassName="d-flex"
                          //onClick={() => this.setDiscountDollarAmount(values)}
                          checked={values.discountType === "DollarAmount"}
                        />
                      </div>
                    </div>
                    <div className="row">
                      {values.discountType === "Percentage" ?
                        <div className="w-100 percent-field-addon">
                          <Field
                            id="discountPercentage"
                            name="discountPercentage"
                            type="number"
                            placeholder=""
                            className="form-control form-field"
                          />
                          {errors.discountPercentage && (<ErrorMessage name="discountPercentage" component="div" className="error-message" />)}
                        </div>
                        :
                        <div className="w-100 dollar-field-addon">
                          <Field
                            id="discountDollarAmount"
                            name="discountDollarAmount"
                            type="number"
                            placeholder=""
                            className="form-control form-field"
                          />
                          {errors.discountDollarAmount && (<ErrorMessage name="discountDollarAmount" component="div" className="error-message" />)}
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>
              <div className="fieldgroup row" >
                <div className="col-6 col-md-5 edit-field-parent reset-padding" >
                  <div className="row padding-left-15" >
                    <div className="field-title">
                      Valid Dates
                    </div>
                    <div className="field-description">
                      Is this discount only available on certain dates?
                    </div>
                  </div>
                </div>
                <div className="col-6 col-md-7 edit-field-parent" >
                  <div className="edit-radio-button-container" >
                    <div className="row">
                      <div className="col-12 col-md-6 reset-padding">
                        <FormikRadioButtonAlternate
                          name="hasDateRange" value={true}
                          label="Yes" checked={values.hasDateRange}
                        />
                      </div>
                      <div className="col-12 col-md-6 reset-padding">
                        <FormikRadioButtonAlternate
                          name="hasDateRange" value={false}
                          label="No" checked={!values.hasDateRange}
                        />
                      </div>
                    </div>
                    {!values.hasDateRange && (<div className="row">
                      <div className="disclaimer">If you do not set dates, the code will be valid as soon as you save it and will never expire.</div>
                    </div>)}
                  </div>
                </div>
              </div>
              {
              renderDates(values, this.toRef, setFieldValue, addValidDates, removeValidDate)
              }
            </Form>
            );
          } }
        </Formik>
      </div>
    </div>
    );
  }

  renderButtonRow( onClose, buttonText ) {
    return (
      <div className="w-100 row align-items-center m-0" >
        <div className="col text-center pl-0" >
          <label onClick={onClose}>
            Cancel
          </label>
        </div>
        <div className="col text=center" >
          <button className='btn btn-primary' onClick={ this.handleFormSubmit }>{ buttonText }</button>
        </div>
      </div>
    );
  }

  render() {
    let { onClose, errType, errors, discount } = this.props;

    let error = (errType && errors) ? errors.find(e => e.errType === errType) : null;
    let title = discount ? 'Editing Discount' : 'Creating Discount';
    let buttonText = discount ? 'Update Discount' : 'Create Discount';
    return (<ModalComponent
      id="DiscountModal"
      title={title}
      body={this.renderBody(this.bindSubmitForm, this.onSubmit, error)}
      footer={this.renderButtonRow(onClose, buttonText)}
      noMinHeight={true}
      onClose={onClose} />
    );
  }
}

export default DiscountModalComponent;
